"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MultipleColumns;

var _react = _interopRequireWildcard(require("react"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n    > div {\n        text-align: left;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MultipleColumnsWrapper = _styledComponents["default"].section(_templateObject());

function MultipleColumns(props) {
  return /*#__PURE__*/_react["default"].createElement(MultipleColumnsComponent, {
    props: props
  });
}

var MultipleColumnsComponent = _react["default"].memo(function (_ref) {
  var props = _ref.props;
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[props.type];
  var columns = props.columns.map(function (col, i) {
    var width = props.widths.length && props.widths[i] ? props.widths[i] : 100 / props.columns.length + '%';
    var gutter = props.gutter ? props.gutter : spacing.margin;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: 'col' + i,
      style: {
        minWidth: props.minWidth,
        width: 'calc(' + width + ' - ' + gutter / 2 + 'px)'
      }
    }, col);
  });
  return /*#__PURE__*/_react["default"].createElement(MultipleColumnsWrapper, {
    spacing: spacing,
    className: "MultipleColumns " + props.className,
    style: props.style
  }, columns);
}, function (prev, next) {
  return prev.props !== next.props;
});

MultipleColumns.defaultProps = {
  className: '',
  columns: [],
  widths: [],
  gutter: null,
  style: null,
  type: 'default',
  minWidth: null
};